// Build: 2026-05-06T08:26:00Z
export const APP_BASENAME = '/app-react';
export const SESSION_STORAGE_KEY = 'crm.react.session';
export const NOTIFICATIONS_ENABLED = true;
export const INBOXES_ENABLED = true;
export const COMPANIES_ENABLED = true;
export const CUSTOM_FIELDS_ENABLED = true;
export const SCHEDULES_ENABLED = true;
export const TAGS_ENABLED = true;
export const AGENTS_ENABLED = true;
export const KNOWLEDGE_BASE_ENABLED = true;
export const AUTOMATIONS_ENABLED = true;
export const CAMPAIGNS_ENABLED = true;
export const INFORMATIONAL_ENABLED = false;
export const SUBSCRIPTIONS_ENABLED = true;
export const ANALYTICS_ENABLED = true;
export const INTEGRATIONS_ENABLED = true;
export const PROFILE_MUTATIONS_ENABLED = true;

const PROD_BFF_URL = 'https://crm-bff.inteligenciaenegocios.com.br';
const PROD_CRM_SERVICE_URL = 'https://crm-service.inteligenciaenegocios.com.br';

export const BFF_BASE_URL =
  (import.meta as any).env?.VITE_USE_LOCAL_BFF === 'true'
    ? `http://${window.location.hostname}:3003`
    : PROD_BFF_URL;

export const CRM_SERVICE_URL =
  (import.meta as any).env?.VITE_USE_LOCAL_BFF === 'true'
    ? `http://${window.location.hostname}:3002`
    : PROD_CRM_SERVICE_URL;

